/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import ShopifyAgent from '../components/shopifyAgent';

function ProductShopifyAgent() {
  return (
    <div className="main">
      <Header />
      <ShopifyAgent />
      <Footer />
    </div>
  );
}

export default ProductShopifyAgent;
